import {
  ManualAccount,
  PlaidAccount,
} from "@fartherfinance/frontend/api/ExternalAccount/requests/getExternalAccounts";

export interface ExternalAccountName {
  fullName: string;
  name: string;
  mask: string;
}

export const getExternalAccountName = (
  exAcct: PlaidAccount | ManualAccount
): ExternalAccountName => {
  if (exAcct.accountProvider === "plaid") {
    const name = exAcct.details.account.officialName
      ? exAcct.details.account.officialName
      : exAcct.details.account.name;

    const mask = exAcct.details.account.accountNumberMask ?? "";

    return {
      fullName: `${name} (...${mask})`,
      name,
      mask: `(...${mask})`,
    };
  }

  return {
    fullName: `${
      exAcct.details.account.accountTitle
    } ${exAcct.details.account.accountNumber.slice(-4)}`,
    name: exAcct.details.account.accountTitle,
    mask: exAcct.details.account.accountNumber.slice(-4),
  };
};
